import React, { useEffect } from 'react'
import { setRedirectUrl } from '../../Actions/BackofficeLogin.action';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { useDispatch } from 'react-redux';
import BackofficeLoginForm from './Backoffice.LoginForm';
import BackofficeCodeForm from './Backoffice.CodeForm';


const BackofficeLoginPage = (props) => {
    const dispatch = useDispatch();
    const { isAuthenticated } = useTypedSelector((state) => state.backofficeLogin);

    useEffect(() => {
        dispatch(setRedirectUrl(props.redirectUrl));
    }, [props.redirectUrl]);

    return (
        <div className="flex flex-col h-screen justify-center items-center w-full">
            {/* {props.title && <div className='text-2xl font-bold'>{props.title}</div>} */}
            <div className='flex flex-col justify-center items-center shadow-xl rounded-2xl px-13 py-9 min-w-[600px] min-h-[450px] bg-white'>
                {!isAuthenticated ?
                    <BackofficeLoginForm /> :
                    <BackofficeCodeForm />}
            </div>
        </div>
    )
}

export default BackofficeLoginPage;

